
import futureDateRangeComposition from '@/app/shared/compositions/FutureDateRange'
import pastDateRangeComposition from '@/app/shared/compositions/PastDateRange'
export default function dateRange (props) {
  return props.futureDateRange ? futureDateRangeComposition(props) : pastDateRangeComposition(props)
}



// WEBPACK FOOTER //
// ./src/app/shared/compositions/DateRange.js